@if (label()) {
    <p-floatlabel [variant]="labelVariant()">
        <ng-container [ngTemplateOutlet]="control" />
        <label [attr.for]="inputId()">
            {{ label() }}
            @if (required()) {
                <span>*</span>
            }
        </label>
    </p-floatlabel>
} @else {
    <ng-container [ngTemplateOutlet]="control" />
}
<ng-template #control>
    <p-datepicker
        #datePicker
        [inputId]="inputId()"
        [placeholder]="placeholder() ?? ''"
        [maxDate]="maxDate()"
        [size]="size()"
        dateFormat="mm/dd/yy"
        showIcon
        iconDisplay="input"
        appendTo="body"
        fluid
        [invalid]="showInvalid()"
        [disabled]="disabled()"
        [ngModel]="value()"
        (ngModelChange)="handleChange($event)"
        (onBlur)="handleBlur($event)"
        (keydown.enter)="formatTypedValue($event)"
        (paste)="formatPastedValue($event)"
        [ngModelOptions]="standaloneNgModel" />
</ng-template>
@if (showError() && errorMessage(); as message) {
    <small class="kno2-form-control">{{ message }}</small>
}
